import { render, staticRenderFns } from "./OCPopup.vue?vue&type=template&id=7aa47092&scoped=true&"
import script from "./OCPopup.vue?vue&type=script&lang=ts&"
export * from "./OCPopup.vue?vue&type=script&lang=ts&"
import style0 from "./OCPopup.vue?vue&type=style&index=0&id=7aa47092&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa47092",
  null
  
)

export default component.exports